import { LoadingController } from '@ionic/angular';

export class LoadingComponent {
    constructor(public loadingController: LoadingController) {

    }

    async showLoading(message: string = "Carregando..", duration: number = 0) {
        const loading = await this.loadingController.create({
          //message,
          duration,
          mode: 'ios',
          keyboardClose: true
        });
        await loading.present();
        return loading
    }
}